import { Directive, Input, OnDestroy, OnInit, Optional, Self, SkipSelf, inject } from '@angular/core';
import { FormGroupDirective as AngularFormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';

/**
 * extends base FormGroupDirective functionality
 * handles submits of sub-forbs
 */
@Directive({
  selector: '[formGroup]',
  standalone: false
})
export class FormGroupDirective implements OnInit, OnDestroy {
  private formGroupDirective = inject(AngularFormGroupDirective, { self: true });
  private parentFormGroupDirective = inject(AngularFormGroupDirective, { optional: true, skipSelf: true });

  @Input('formGroup') form: UntypedFormGroup = null!;
  private destroyed = new Subject<void>();

  

  ngOnInit(): void {
    if (this.parentFormGroupDirective) {
      this.parentFormGroupDirective.ngSubmit.pipe(takeUntil(this.destroyed)).subscribe((event: any) => {
        this.formGroupDirective.onSubmit(event);
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
